import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { CheckCircle2 } from "lucide-react";

/**
 * InstallModal — Confirmación de instalación de un item técnico de la provisión.
 *
 * Extraído 1:1 desde `pages/ProvisionsPage.js`. Pide la fecha de instalación y confirma
 * el marcado del item (y sus bonos asociados) como INSTALADO.
 *
 * @param {boolean}  props.installModalOpen    Apertura del diálogo.
 * @param {Function} props.setInstallModalOpen  Setter del flag de apertura.
 * @param {string}   props.installDate          Fecha de instalación seleccionada.
 * @param {Function} props.setInstallDate       Setter de la fecha de instalación.
 * @param {Function} props.handleInstallItem    Confirma la instalación del item técnico.
 */
export const InstallModal = ({
  installModalOpen,
  setInstallModalOpen,
  installDate,
  setInstallDate,
  handleInstallItem,
}) => {
  return (
      <Dialog open={installModalOpen} onOpenChange={setInstallModalOpen}>
        <DialogContent className="bg-[#0A0A35] border-[#1E1E5F] text-white max-w-sm" data-testid="install-modal">
          <DialogHeader>
            <DialogTitle className="text-white flex items-center gap-2">
              <CheckCircle2 className="h-5 w-5 text-green-400" />
              Confirmar Instalación
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 mt-2">
            <div>
              <Label className="text-slate-300">Fecha de instalación *</Label>
              <Input
                type="date"
                data-testid="install-date-input"
                value={installDate}
                onChange={(e) => setInstallDate(e.target.value)}
                className="mt-1 bg-[#0A0A35] border-[#1E1E5F] text-white"
              />
            </div>
            <div className="flex gap-2 justify-end">
              <Button variant="outline" onClick={() => setInstallModalOpen(false)}
                className="border-[#1E1E5F] text-slate-300 hover:bg-[#1E1E5F]">
                Cancelar
              </Button>
              <Button data-testid="confirm-install-btn" disabled={!installDate} onClick={handleInstallItem}
                className="bg-green-600 hover:bg-green-700 disabled:opacity-40">
                Confirmar instalación
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
  );
};
